<template>
  <div class="table-page">
    <top-bar :topbarList="oilGunTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";

import { oilGunIndexMixins } from "@/mixins/oilGunIndexMixins";

export default {
  mixins: [oilGunIndexMixins],
  data() {
    return {};
  },
  computed: {
    topbarList() {
      let topbarList = [
        {
          name: "油枪管理",
          isActive: false,
          path: "/oilGun",
        },
      ];
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
      });
      return topbarList;
    },
  },
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.table-page {
  height: 100%;
}
</style>
